var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Checkbox',_vm._b({on:{"change":_vm.updateValue}},'Checkbox',{
              ..._vm.$props,
              label: _vm.attestationLabel,
              value: _vm.checkboxValue
            },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }